module.exports = __webpack_public_path__ + "img/icon_sec3_01.528958b0.png";